import React from 'react';
import { IMAGE_URL, ENVIRONMENT, S3_BUCKET } from '../../config/configuration';

const sizeOrdinals = ['small', 'medium', 'large', 'extraLarge'];

const sizeMap = {
  small: 45,
  medium: 90,
  large: 135,
  extraLarge: 180,
};

const buildLogoImageUrl = (width, clientId, companyLogo) => {
  const imageRequest = {
    bucket: S3_BUCKET,
    key: `tenant-assets/${ENVIRONMENT}/${clientId}/images/${companyLogo}`,
    edits: {
      resize: {
        width,
        fit: 'contain',
      },
    },
  };
  return `${IMAGE_URL}/${btoa(JSON.stringify(imageRequest))}`; // eslint-disable-line no-undef
};

const imageSource = (clientId, companyLogo, size) => {
  const width = sizeMap[size];
  if (companyLogo && clientId) {
    return buildLogoImageUrl(width, clientId, companyLogo);
  }
  return `/images/loan-icon-${width}x${width}.png`;
};

const imageSourceSet = (clientId, companyLogo, size) => {
  const sources = [];
  for (let i = sizeOrdinals.indexOf(size); i < sizeOrdinals.length; i += 1) {
    const source = imageSource(clientId, companyLogo, sizeOrdinals[i]);
    sources.push(source);
  }
  return sources.map((source, i) => `${source} ${i + 1}x`).join(',');
};

const companyLogoImage = ({
  size, companyLogo, clientId, companyDisplayName,
}) => {
  const src = imageSource(clientId, companyLogo, size);
  const srcSet = imageSourceSet(clientId, companyLogo, size);
  return (<img alt={companyDisplayName} className="companyLogo" src={src} srcSet={srcSet} />);
};

export default companyLogoImage;
